import React, { Fragment } from 'react';
import CountUp from 'react-countup';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';
import { H5, H4, H6, LI, UL, Image } from '../../../AbstractElements';
import userCard from '../../../assets/images/general-widget/user-profile.png';
import { Follower, Following, JohnCarter, Manager, TotalPost } from '../../../Constant';
import { SocialList } from '../../../Data/Widgets/general';
const ManagerProfile = () => {
  return (
    <Fragment>
      <Col xl='4' md='6' className='box-col-4 lg-50 dash-lg-50'>
        <Card className='custom-profile'>
          <CardBody>
            <div className='card-profile'>
              <Image className='user-img' src={userCard} alt='' />
            </div>
            <div className='text-center profile-details'>
              <H4>{JohnCarter}</H4>
              <H6>{Manager}</H6>
            </div>
            <UL className='simple-list card-social flex-row'>
              {SocialList.map((item, i) => (
                <LI key={i} className={item.color}>
                  <a className='social-link d-flex align-items-center justify-content-center' href={item.url}>
                    {item.icon}
                  </a>
                </LI>
              ))}
            </UL>
          </CardBody>
          <CardFooter>
            <Row>
              <Col sm='4 col-4'>
                <H6>{Follower}</H6>
                <H5>
                  <CountUp className='counter' end={9564} />
                </H5>
              </Col>
              <Col sm='4 col-4'>
                <H6>{Following}</H6>
                <H5>
                  <CountUp className='counter' end={49} />K
                </H5>
              </Col>
              <Col sm='4 col-4'>
                <H6>{TotalPost}</H6>
                <H5>
                  <CountUp end={96} className='counter' />M
                </H5>
              </Col>
            </Row>
          </CardFooter>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ManagerProfile;
